/* CK 7 Oct 26: push sold-out products to the end of a collection grid.
   Shopify has no inventory-aware sort and smart collections cannot be ordered
   manually, so this is done in the grid. The grid uses infinite scroll, so the
   whole collection ends up as one continuous list and moving the sold-out
   cards to the bottom reads as "at the end" rather than "end of this page".
   Nothing is hidden: every sold-out product stays in the grid, keeps its page
   and keeps its Notify Me form. */
(function () {
  var GRID = '#main-collection-product-grid';

  function reorder() {
    var grid = document.querySelector(GRID);
    if (!grid) return;
    var out = grid.querySelectorAll(':scope > [data-sold-out="true"]');
    if (!out.length) return;
    // append in their existing relative order, so sold-out keeps the
    // collection's own sort among itself
    for (var i = 0; i < out.length; i++) {
      if (out[i].nextElementSibling) grid.appendChild(out[i]);
    }
  }

  function boot() {
    reorder();
    var grid = document.querySelector(GRID);
    if (!grid) return;
    // infinite scroll appends more cards, so re-run when children change
    var pending = null;
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(reorder, 120);
    }).observe(grid, { childList: true });
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
